import { withInstall } from '@vuemap/vue-amap-util'
import Labels from './Labels.vue'

export const ElAmapLayerLabels = withInstall(Labels)
export default ElAmapLayerLabels
